import { render, staticRenderFns } from "./Drop.vue?vue&type=template&id=165ed66d&scoped=true&"
import script from "./Drop.vue?vue&type=script&lang=js&"
export * from "./Drop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ed66d",
  null
  
)

export default component.exports